module.exports = __webpack_public_path__ + "static/img/relação_de_nfs.0bb9890.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loja/relação_de_nfs.png
// module id = 839
// module chunks = 0